import { Pipe, PipeTransform } from '@angular/core';
import { Observable, of, isObservable } from 'rxjs';

@Pipe({
  name: 'toObservable',
  standalone: false,
})
export class ToObservablePipe implements PipeTransform {
  transform(value: string | Observable<any>): Observable<string> {
    return (isObservable(value) ? value : of(value)) as Observable<string>;
  }
}
